import React from 'react'
import classes from './css/page-not-found.module.css';
import {Link, useHistory} from "react-router-dom";
import {Col, Row, Card, Typography, Image, Layout} from 'antd';
import PageNotFoundImage from './assests/images/page-not-found.png';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MetaTags from "react-meta-tags";

const {Content} = Layout;

const PageNotFound = () => {
    const history = useHistory();
    return (
        <div className="mainbody">
            <Content className="main">
                <div className="page">
                    <div className="container">
                        <MetaTags>
                            <title>TecMe: 404</title>
                            <meta name="description" content={"Tech support for your home or business provided by trusted local technicians."}/>
                            <meta name="robots" content="noindex, nofollow"/>
                        </MetaTags>
                        <Row gutter={[16, 16]}>
                            <Col span={12} className={classes.Card} style={{padding: 15}}>
                                <div>
                                    <h1 className={classes.heading}>Sorry, this page isn’t available</h1>
                                    <p style={{
                                        color: '#B1B1B1',
                                        fontWeight: 400,
                                        marginRight: '4rem'
                                    }}>The page you were looking for could not be found. Double check the page URL or click the link below to go back to the
                                        Home
                                        page.</p>
                                    <Link onClick={() => history.push("/")} style={{textDecoration: 'none', color: 'black'}}><ArrowBackIcon
                                        fontSize="small"/> Go
                                        back to the home page</Link>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                    <img loading="lazy"  style={{padding: '3rem', width: "90%", height: '90%'}} src={PageNotFoundImage}/>
                                    <div className={classes.check}>
                                        <h1 className={classes.heading}>Sorry, this page isn’t available</h1>
                                        <p style={{
                                            color: '#B1B1B1',
                                            fontWeight: 250,

                                        }}>The page you were looking for could not be found. Double check the page URL or click the link below to go back to the
                                            Home page.</p>
                                        <Link onClick={() => history.push("/")} style={{textDecoration: 'none', color: 'black'}}><ArrowBackIcon
                                            fontSize="small"/> Go back to the home page</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Content>
        </div>
    )
}

export default PageNotFound;